module.exports = __webpack_public_path__ + "images/3fa3ffc4339638f55870aad54abe5dbe.svg";